<template>
  <v-container>
    <v-row>
      <v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import snackbarMixin from '@/mixins/snackbar.mixin'
import pageMixin from '@/mixins/page.mixin'


export default {
  mixins: [
    snackbarMixin,
    pageMixin
  ],


  async created () {
    try {
      this.setPageTitle(this.$t('nav.profile'))
    } catch (error) {
      this.showSnackbarError()
      this.$log.error(error)
    } finally {
      this.stopPageLoading()
    }
  }
}
</script>
